var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionValidated(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 60,
    cy: 60.862,
    r: 60
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.652 39c11.957 0 21.651 9.694 21.651 21.652 0 11.957-9.694 21.651-21.651 21.651C47.694 82.303 38 72.61 38 60.652 38 48.694 47.694 39 59.652 39zM71.17 53.946a1.745 1.745 0 0 0-2.256.02L56.905 64.317l-6.604-5.968-.122-.1a1.704 1.704 0 0 0-2.111.055 1.283 1.283 0 0 0-.04 1.937l7.758 7.01.122.1c.625.47 1.5.455 2.111-.054a1.28 1.28 0 0 0 .284-.333l12.883-11.108a1.253 1.253 0 0 0-.016-1.911z",
    id: "b"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 4)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#4CD964",
    strokeWidth: 4,
    cx: 60,
    cy: 60.862,
    r: 62
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#4CD964",
    xlinkHref: "#b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionValidated);
export default __webpack_public_path__ + "static/media/action-validated.c5cd6bea21a41d07854c50d5b30da577.svg";
export { ForwardRef as ReactComponent };